import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=768e1d48&scoped=true"
import script from "./Legends.vue?vue&type=script&lang=js"
export * from "./Legends.vue?vue&type=script&lang=js"
import style0 from "./Legends.vue?vue&type=style&index=0&id=768e1d48&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768e1d48",
  null
  
)

export default component.exports